import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdCommercialRule() {
  return useQuery({
    queryKey: ['rd-commercial-rule'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getCommercialRule();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar a regra comercial do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
